import { FileObject } from '../services/file-upload.service';

export interface App {
  id: string;
  vendor: string;
  name: string;
  description: string | null;
  url: string;
  iconUrl: string | null;
  configFormUrl: string | null;
  configScheme: unknown;
  configSchemeVersion: string;
  configDefault: unknown;
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface ConfiguredApp  {
  id: string;
  vid: string;
  appId: string;
  chainId: number;
  name: string;
  description: string;
  configSchemeVersion: string;
  published: boolean;
  publishedAt: string | null;
  files?: FileObject[];
  config?: string;
  restaurants: {
    all: boolean,
    ids: number[]
  };
  createdAt: string;
  updatedAt: string;
}

export interface NewAppConfiguration {
  appId: string;
  name: string;
  description: string;
  configSchemeVersion?: string;
  config: unknown;
  published: boolean;
  files?: number[];
  restaurants: {
    all: boolean;
    ids: number[];
  };
}

export interface AppResolveData {
  app: App;
  configuredApps: ConfiguredApp[];
}
